import { toasterMsg } from '../../../Components/Toaster/Toaster';
import t from './User.type';
import { userRightsService, supplierPermissionService } from '../../../services/user-rights-management.service';
import * as requiredDocumentService from '../../../services/requiredDocument.service';
import * as accountDetailsServices from '../../../services/account-details.services';
import devT from '../../DevlopmentOrder/store/DevelopmentOrder.type';
import { backendErrorMsg, getApiErrorKey } from '../../../Components/helper';

// *****fetchlogin******
export const fetchLogInRights = (params) => async (dispatch) => {
  const res = await userRightsService(params);
  try {
    if (res.code === 200 && res.data) {
      await dispatch({
        type: t.FETCH_USER_RIGHTS,
        payload: res.data,
      });
      dispatch(greeedyMenuLoader(false));
    } else {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchSupplierPermissionService = () => async () => {
  try {
    const res = await supplierPermissionService();
    if (res?.code === 200 && res?.data) {
      return res.data;
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchUserDocumentsList = (query) => async (dispatch) => {
  const res = await requiredDocumentService.getRequiredDocuments(query);
  try {
    if (res.code === 200 && res.data) {
      await dispatch({
        type: t.USER_DOCS,
        payload: res.data,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addUserDocumentsList = (params, transactionMsg, type) => async () => {
  try {
    const res = await requiredDocumentService.addDocument(params);
    let msg = '';
    if (res?.code === 200) {
      if (type === 'add/update') {
        msg = transactionMsg('REQUIRED_DOCUMENT.BACKEND_SERVICE.DOCUMENT_TYPES_ADDED');
      } else if (type === 'active') {
        msg = transactionMsg('REQUIRED_DOCUMENT.BACKEND_SERVICE.DOCUMENT_ACTIVE_STATUS_UPDATED');
      }
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.code === 400) {
      const transMsg = transactionMsg(res?.data?.errMsg);
      toasterMsg(transMsg, 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateDocumentTypeSequence = (params, transactionMsg) => async () => {
  try {
    const res = await requiredDocumentService.updateDocumentTypeSequence(params);
    if (res?.code === 200) {
      const msg = transactionMsg('REQUIRED_DOCUMENT.BACKEND_SERVICE.DOCUMENT_TYPES_UPDATED');
      toasterMsg(msg, 'success');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteUserDocument = (params, transactionMsg) => async (dispatch) => {
  try {
    const res = await requiredDocumentService.deleteDocument(params.docId);
    if (res?.code === 200) {
      await dispatch({
        type: t.DELETE_USER_DOC,
        payload: params.index,
      });
      const msg = transactionMsg('REQUIRED_DOCUMENT.BACKEND_SERVICE.DOCUMENT_TYPES_DELETED');
      toasterMsg(msg, 'success');
    }
    if (res?.code === 400) {
      const msg = transactionMsg('REQUIRED_DOCUMENT.BACKEND_SERVICE.DOCUMENT_TYPES_USED');
      toasterMsg(msg, 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const unmountAction = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR,
      payload: [],
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

// *****userGroupsCards******
export const fetchUserGroupsCards = (data) => async (dispatch) => {
  const res = await requiredDocumentService.getUserGroupsCardList(data);
  try {
    if (res.code === 200 && res.data) {
      await dispatch({
        type: t.GET_USERS_GROUPS_CARD,
        payload: res.data,
      });
    } else {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addUserGroupsCards = (params, transactionMsg) => async () => {
  try {
    const res = await requiredDocumentService.addUserGroupsCardList(params);
    if (res?.code === 200) {
      const msg = transactionMsg('USER_GROUP.USER_GROUP_ADDED');
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteUserGroupsCards = (params, transactionMsg) => async (dispatch) => {
  try {
    const res = await requiredDocumentService.deleteUserGroupsCardList(params);
    if (res?.code === 200) {
      const msg = transactionMsg('USER_GROUP.USER_GROUP_DELETED');
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateUserGroupsCards = (params, transactionMsg) => async () => {
  try {
    const res = await requiredDocumentService.updateUserGroupsCardList(params);
    if (res?.code === 200) {
      const msg = transactionMsg('USER_GROUP.USER_GROUP_UPDATED');
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getUserGroupsCardListbyid = (params, transactionMsg) => async (dispatch) => {
  try {
    const res = await requiredDocumentService.getUserGroupsCardListbyid(params);
    if (res.code === 200 && res.data) {
      await dispatch({
        type: t.GET_USERGROUPS_BYID,
        payload: res.data,
      });
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
export const updateUserGroupsDetails = (params, transactionMsg) => async () => {
  try {
    const res = await requiredDocumentService.updateUserGroups(params);
    if (res?.code === 200) {
      const msg = transactionMsg('USER_GROUP.USER_GROUP_RIGHTS_UPDATED');
      toasterMsg(msg, 'success');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

// *****usersLibrary******
export const fetchUsersLibrary = (params) => async (dispatch) => {
  try {
    const res = await requiredDocumentService.getUserLibraryList(params);
    if (res.code === 200 && res.data !== undefined) {
      await dispatch({
        type: t.GET_USERS_LIBRARY_LIST,
        payload: res.data,
      });
    } else {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchSupplierUsersList = (params, transactionMsg) => async (dispatch) => {
  try {
    const res = await requiredDocumentService.getSupplierUsersList(params);
    if (res.code === 200 && res.data !== undefined) {
      await dispatch({
        type: t.GET_SUPPLIER_USERS_LIST,
        payload: res.data,
      });
    } else {
      toasterMsg(transactionMsg ? transactionMsg(res?.data?.errMsg) : res?.data?.errMsg, 'danger');
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteUsersLibraryGroup = (params, transactionMsg) => async (dispatch) => {
  try {
    const res = await requiredDocumentService.deleteUsersLibrary(params);
    if (res?.code === 200) {
      const msg = transactionMsg('USER.USER_DELETED');
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateUsersLibraryStatus = (params) => async () => {
  try {
    const res = await requiredDocumentService.updateUsersStatus(params);
    if (res?.code === 200) {
      toasterMsg(res.message, 'success');
    } else {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateUsersLibrary = (params, transactionMsg) => async () => {
  try {
    const res = await requiredDocumentService.updateUsersLibrary(params);
    if (res?.code === 200) {
      const msg = transactionMsg('REQUIRED_DOCUMENT.BACKEND_SERVICE.DOCUMENT_TYPES_UPDATED');
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const resetPasswordMail = (params, transactionMsg) => async () => {
  try {
    const res = await requiredDocumentService.updatePassword(params);
    if (res?.code === 200) {
      const msg = transactionMsg('USER.SETUP_EMAIL_SENT');
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(`AUTHENTICATION.${res?.data?.errMsg}`), 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addUser = (params, transactionMsg) => async () => {
  try {
    const res = await requiredDocumentService.addUserService(params);
    if (res?.code === 200) {
      const msg = transactionMsg('USER.USER_ADDED');
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateUsersDetails = (params, transactionMsg) => async () => {
  try {
    const res = await requiredDocumentService.updateUsersDetails(params);
    if (res?.code === 200) {
      const msg = transactionMsg('USER.USER_UPDATED');
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const mainModuleRights = (params) => async (dispatch) => {
  try {
    await dispatch({
      type: t.MODULE_ACCESS_RIGHTS,
      payload: params,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
export const allSectionRights = (params) => async (dispatch) => {
  try {
    await dispatch({
      type: t.SECTION_ACCESS_RIGHTS,
      payload: params,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

//  subscription detail api check
export const getSubscriptionDetails = () => async (dispatch) => {
  try {
    const res = await requiredDocumentService.companySubscriptions();
    if (res?.code === 200) {
      await dispatch({
        type: t.SUBSCRIPTION_PERMISSION,
        payload: res.data,
      });
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getProfileDetails = (params) => async (dispatch) => {
  try {
    const res = await accountDetailsServices.getUserProfileDetails(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.PROFILE_DETAILS,
        payload: res.data,
      });
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const editProfileDetails = (data, trans) => async () => {
  try {
    const res = await accountDetailsServices.editUserProfileDetails(data);
    if (res && res.code === 200) {
      toasterMsg(trans(res.message), 'success');
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const changePassword = (data, trans) => async () => {
  try {
    const res = await accountDetailsServices.changeUserPassword(data);
    if (res?.code === 200) {
      toasterMsg(trans(`ACCOUNT_DETAILS.${res.message}`), 'success');
      return true;
    }
    if (res?.data?.errMsg) {
      toasterMsg(trans(res?.data?.errMsg), 'danger');
    }
  } catch (err) {
    toasterMsg(backendErrorMsg(trans, getApiErrorKey(err)), 'danger');
  }
  return null;
};

export const getSupplierProfileDetails = (params) => async (dispatch) => {
  try {
    const res = await accountDetailsServices.getSupplierProfileDetails(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.PROFILE_DETAILS,
        payload: res.data,
      });
    }
    if (res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const editSupplierProfileDetails = (data, trans) => async () => {
  try {
    const res = await accountDetailsServices.editSupplierProfileDetail(data);
    if (res?.code === 200) {
      toasterMsg(trans(`ACCOUNT_DETAILS.${res.message}`), 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      toasterMsg(trans(res?.data?.errMsg), 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return null;
};

export const getUserProfileDetails = (params) => async (dispatch) => {
  try {
    const res = await accountDetailsServices.getSupplierUserProfileDetails(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.PROFILE_DETAILS,
        payload: res.data,
      });
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const editUserProfileDetails = (data, trans) => async () => {
  try {
    const res = await accountDetailsServices.editUserProfileDetail(data);
    if (res?.code === 200) {
      toasterMsg(trans(`ACCOUNT_DETAILS.${res.message}`), 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      toasterMsg(trans(res?.data?.errMsg), 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return null;
};

export const setNewPassChange = (data, trans) => async () => {
  try {
    const res = await accountDetailsServices.setNewPassword(data);
    if (res?.code === 200) {
      toasterMsg(trans(`ACCOUNT_DETAILS.${res.message}`), 'success');
      return true;
    }
    if (res?.data?.errMsg) {
      toasterMsg(trans(res?.data?.errMsg), 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return null;
};

export const fetchCurrencyPermission = (params) => async (dispatch) => {
  try {
    const res = await accountDetailsServices.getCurrencyPermission(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.CURRENCY_PERMISSION,
        payload: res.data,
      });
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

// export const getTheSlugsUsedStorage = () => async (dispatch) => {
//   try {
//     const res = await accountDetailsServices.getTheSlugsUsedStorageService();
//     if (res?.code === 200) {
//       await dispatch({
//         type: t.STORAGE_USER_BY_SYSTEM_BY_SLUG,
//         payload: res.data,
//       });
//     }
//   } catch (err) {
//     toasterMsg(err.toString(), "danger");
//   }
// };

export const greeedyMenuLoader = (val) => async (dispatch) => {
  try {
    await dispatch({
      type: devT.CUSTOM_MODULE_MENU_LOADING_STATE,
      payload: val,
    });
  } catch (err) {
    console.log(err.toString());
  }
};
